<template>
  <div>
    <div class="loginWrap" :class="{miniWrap: platform}">
      <div class="login-content">
        <div class="close-btn" @click="hiddenLoginOut"></div>
        <p>是否确定退出当前账号？</p>
        <div class="login-btn">
          <div class="cancel" @click="hiddenLoginOut">取消</div>
          <div class="quit" @click="quit">退出</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'loginout',
  data() {
    return {
    }
  },
  computed: {
    ...mapState([
      'platform'
    ])
  },
  methods: {
    ...mapMutations(['setUserInfo', 'setLoginOutWrap']),
    hiddenLoginOut() {
      this.setLoginOutWrap(false)
    },
    quit() {
      this.setLoginOutWrap(false)      
      this.$router.push('/')
      localStorage.setItem('akc_userId', '')
      localStorage.setItem('akc_userPhone', '')
      localStorage.setItem('akc_userName', '')
      localStorage.setItem('akc_akid', '')
      localStorage.setItem('akc_token', '')
      localStorage.setItem('akc_vip_level', '')
      this.setUserInfo()
    }
  }
}
</script>

<style scoped lang="less">
  .loginWrap {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1000;
    background: rgba(51,51,51,.7);
    .login-content {
      width: 320px;
      height: 190px;
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      border-radius: 2px;
      .close-btn {
        height: 20px;
        width: 20px;
        background-image: url('../common/img/close.png');
        background-size: 100% 100%;
        position: absolute;
        top: 17px;
        right: 17px;
        cursor: pointer;
      }
      p {
        padding: 47px 0;
        text-align: center;
        font-size:16px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:22px;
      }
      .login-btn {
        padding: 0 30px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .cancel, .quit {
          width:120px;
          height:44px;
          border-radius:2px;
          line-height: 44px;
          font-size:14px;
          font-family:PingFangSC-Regular;
          font-weight:400;
          cursor: pointer;
        }
        .cancel {
          color: #333;
          border:1px solid rgba(153,153,153,1);
          background: #fff;
        }
        .quit {
          color: #fff;
          background:rgba(236,34,50,1);
        }
      }
    }
  }
</style>
